module.exports = __webpack_public_path__ + "static/media/certificados.7caa0a18.svg";